var map = {
	"./about-us.jpg": 5584,
	"./digital-marketing-network.jpg": 7058,
	"./digital-marketing-note.jpg": 8518,
	"./digital-marketing-plan.jpg": 826,
	"./digital-marketing-service.jpg": 5797,
	"./digital-marketing.jpg": 7427,
	"./form.jpg": 4559,
	"./seo.jpg": 8423,
	"./web-design.jpg": 3096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1797;